export default __webpack_public_path__ + "cfcd94a74459ce7c0a828ff4581dd72c.png";